'use client';

import AuthInput from '@/@shared/components/forms/AuthInput';
import SubmitButton from '@/@shared/components/primitives/Button/SubmitButton';
import { useTransAuth } from '@/@shared/hooks/useTranslations';
import type { PannelProps } from '@/app/[locale]/(auth)/signup/(funnel)/PannelType';
import styles from '@/app/[locale]/(auth)/signup/(funnel)/RegisterComp.module.scss';
import { clc } from '@/legacy/components/base/utils';
import { errorStyle } from '@/legacy/components/input/inputUtil';
import type { SignUpType } from '@/model/zod/authZod';
import { useFormContext } from 'react-hook-form';

type GetEmailProps = PannelProps & {
	onSendEmail: (email: string) => Promise<boolean>;
	isSending?: boolean;
};

const GetEmail = ({ locale, onNext, onSendEmail, isSending }: GetEmailProps) => {
	const t = useTransAuth('signup.emailInput');

	const {
		register,
		setValue,
		getValues,
		watch,
		formState: { errors },
	} = useFormContext<SignUpType>();

	const getEmailRegister = register('getEmail', {
		required: true,
	});

	// watch를 사용하여 리액티브하게 값 감시 (복붙 대응)
	const emailValue = watch('getEmail');

	const handleGetEmailClick = async () => {
		if (!errors.getEmail) {
			const emailValue = getValues('getEmail');

			if (!emailValue) {
				return;
			}

			const success = await onSendEmail(emailValue);
			if (success) {
				onNext();
			}
		}
	};

	// Enter 키로 다음 단계로 진행
	const handleEnterPress = () => {
		const isValid = !errors.getEmail && Boolean(emailValue);
		if (isValid && !isSending) {
			handleGetEmailClick();
		}
	};

	return (
		<>
			<div className={clc(styles.title, styles.under20)}>
				<div className={styles.line2}>
					<span>{t('description')}</span>
				</div>
			</div>
			<AuthInput
				className={errorStyle(errors.getEmail?.message?.toString())}
				errors={errors}
				keyName={'getEmail'}
				// label={t('label.getEmail')}

				required
				{...getEmailRegister}
				autoComplete="off"
				getValues={getValues}
				placeholder={t('placeholder')}
				setValue={setValue}
				style={{ position: 'relative' }}
				type="email"
				onEnterPress={handleEnterPress}
			/>
			<div className={styles.submitArea}>
				<SubmitButton
					loading={isSending || false}
					isValid={!errors.getEmail && Boolean(emailValue)}
					onClick={handleGetEmailClick}
					action={t('submit')}
					loadingText={t('loading')}
					type="button"
					fullWidth
				/>
			</div>
		</>
	);
};

export default GetEmail;
